var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurveGbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 120,
    viewBox: "0 0 1440 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M797.232 88.7404C1122.77 145.355 1361.38 112.33 1440 88.7404V0H0V88.7404C130.104 65.1512 471.695 32.1263 797.232 88.7404Z",
    fill: "#CFE6DB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveGbg);
export default __webpack_public_path__ + "static/media/curveGbg.717caeebd1656424ea00097b44e5ff73.svg";
export { ForwardRef as ReactComponent };